module.exports = __webpack_public_path__ + "images/assets/7e0dab4a44cdfe62d281e58033960200.svg";